module.exports = __webpack_public_path__ + "img/1_23.09.27_2138_S18ASP_R1_01.e12d4106.jpg";